import { createContext } from "react";
import { initialState } from "../reducers/reducer";

export const StateContext = createContext(initialState);
export const StateDispatchContext = createContext(null);
